import { cn } from '../../utils/cn';

function initialsFromName(name: string | null | undefined) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase() ?? '')
    .join('');
}

// Kullanıcı avatarı bir ikon değildir — "ikon çerçeveye kapatılmaz" kuralının
// istisnasıdır (SINIF_PLATFORM_PLAN.md §2.3).
export function Avatar({ name, size = 40, className }: { name: string | null | undefined; size?: number; className?: string }) {
  return (
    <div
      className={cn('rounded-full bg-accent-100 text-accent-600 flex items-center justify-center font-black shrink-0', className)}
      style={{ width: size, height: size, fontSize: size * 0.36 }}
    >
      {initialsFromName(name)}
    </div>
  );
}
